module.exports = __webpack_public_path__ + "static/img/top-seller-badge-disabled.147fc60b.svg";